import apiClient from '../../shared/auth/services'

/**
 * モバイル会員登録サービス
 * 会員登録、メールアドレス重複チェック、ログインチェックなどの会員管理機能を提供
 */
export const mobileKaiinTorokuService = {
  /**
   * メールアドレスの重複チェック
   * 指定されたメールアドレスが既に登録されているかチェック
   * @param {string} mailAddress - チェック対象のメールアドレス
   * @returns {Promise<Object>} 重複チェック結果
   */
  async getPixUserCount(mailAddress) {
    const response = await apiClient.post('/getPixUserCount', {
      mailAddress: mailAddress
    })
    return response.data
  },

  /**
   * ユーザー登録
   * 新しいユーザーをシステムに登録
   * @param {Object} userData - ユーザー登録データ
   * @param {string} userData.userName - ユーザー名
   * @param {string} userData.loginPassword - ログインパスワード
   * @param {string} userData.mailAddress - メールアドレス
   * @returns {Promise<Object>} 登録結果
   */
  async addPixUser(userData) {
    const response = await apiClient.post('/addPixUser', {
      use_init: "false",        // 初期化フラグ（新規登録時はfalse）
      action: "new",            // アクション種別（新規登録）
      userName: userData.userName,
      loginPassword: userData.loginPassword,
      mailAddress: userData.mailAddress,
      pixtagRiyoFlg: true,      // Pixtag利用フラグ（デフォルトでtrue）
      objectIdAutoFlg: 0        // オブジェクトID自動生成フラグ（デフォルトで0）
    })
    return response.data
  },

  /**
   * ログインチェック
   * メールアドレスとパスワードによるログイン認証
   * @param {Object} credentials - ログイン認証情報
   * @param {string} credentials.mailAddress - メールアドレス
   * @param {string} credentials.loginPassword - ログインパスワード
   * @returns {Promise<Object>} ログイン認証結果
   */
  async loginCheckPixtag(credentials) {
    const response = await apiClient.post('/loginCheckPixtag', {
      mailAddress: credentials.mailAddress,
      loginPassword: credentials.loginPassword
    })
    return response.data
  },
}

export default mobileKaiinTorokuService
